import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomatherantempotraveller() {



  const cardData =
  {
    keyword: 'Pune To Matheran Tempo Traveller Hire On Rent',
    heading: 'Sanavi Travels: Pune To Matheran Tempo Traveller Hire On Rent',
    headingDescription: 'Sanavi Travels offers reliable Pune to Matheran Tempo Traveller Hire on Rent, providing safe, comfortable, and hassle-free transportation for families, friends, corporate groups, and tourists planning a scenic hill-station trip from Pune to Matheran. Our fleet of 9, 12, 13, 14, 17, and 26 seater tempo travellers is well-maintained with spacious seating, push-back seats, air-conditioning, music systems, and ample luggage space to ensure a smooth and enjoyable long-distance journey. With experienced drivers, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual service and a stress-free travel experience. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Matheran attractions such as Charlotte Lake, Panorama Point, Louisa Point, Echo Point, One Tree Hill, and Matheran Market. Choose Sanavi Travels for trusted Pune to Matheran tempo traveller hire services, delivering comfort, safety, and a memorable hill-station group travel experience.',

    top: 'Top Places to Visit in Matheran Peeth with Sanavi Travels',


"topPlaces": [
  {
    "title": "Panorama Point",
    "description": "Panorama Point is one of Matheran’s most famous viewpoints, offering breathtaking 360-degree views of the surrounding hills, valleys, and the Western Ghats. It is especially stunning during sunrise and sunset, providing perfect photo opportunities. The point is a favorite among tourists, nature lovers, and trekkers seeking a serene escape."
  },
  {
    "title": "Charlotte Lake",
    "description": "Charlotte Lake is a peaceful and picturesque lake in Matheran, surrounded by lush greenery and walking trails. It is a perfect spot for picnics, relaxation, and enjoying nature. The lake contributes to Matheran’s cool climate and tranquil environment, making it a favorite for visitors seeking calm and scenic beauty."
  },
  {
    "title": "Louisa Point",
    "description": "Louisa Point is a scenic viewpoint known for panoramic views of valleys, distant mountains, and waterfalls. Popular among trekkers and photographers, the viewpoint offers an unforgettable experience, especially during monsoon when the surroundings are lush and misty."
  },
  {
    "title": "Echo Point",
    "description": "Echo Point is a unique location in Matheran where visitors can hear their voices echo across the hills. Surrounded by dense forests and rugged terrain, it is a fun and interactive spot for families and tourists. The point also offers beautiful views of the Western Ghats."
  },
  {
    "title": "One Tree Hill Point",
    "description": "One Tree Hill Point is named after a lone tree that stands on the hilltop, offering panoramic views of the valleys below. It is ideal for nature photography and quiet contemplation. The spot is especially captivating during the monsoon season with misty hills and flowing streams."
  },
  {
    "title": "Alexander Point",
    "description": "Alexander Point is a serene viewpoint in Matheran, providing stunning vistas of the surrounding mountains, valleys, and the distant town. It is less crowded than other points, making it perfect for solitude and enjoying nature’s tranquility. The location is ideal for trekkers and nature enthusiasts."
  },
  {
    "title": "Monkey Point",
    "description": "Monkey Point is a popular viewpoint and spot to see playful monkeys in their natural habitat. It offers sweeping views of the surrounding hills, including the Prabalgad Fort. Visitors often enjoy interacting with the monkeys and capturing scenic photographs of the landscape."
  },
  {
    "title": "Charlotte Plateau",
    "description": "Charlotte Plateau is a scenic area near Charlotte Lake, featuring walking trails, lush greenery, and beautiful viewpoints. It is ideal for short treks, nature walks, and birdwatching. The plateau enhances Matheran’s natural charm and peaceful atmosphere."
  },
  {
    "title": "Matheran Toy Train",
    "description": "The Matheran Toy Train is a historic narrow-gauge train that connects Neral to Matheran, offering a unique travel experience through tunnels, bridges, and scenic landscapes. The ride is especially popular among tourists for its heritage charm and panoramic views of the Western Ghats."
  },
  {
    "title": "Charlotte Waterfalls",
    "description": "Charlotte Waterfalls are seasonal waterfalls near Charlotte Lake, especially spectacular during the monsoon. Surrounded by lush greenery and rocky terrain, the waterfalls are ideal for nature lovers, photography, and short treks. They add to Matheran’s serene and scenic appeal."
  }
]
,




"services": [
  {
    "name": "Pune To Matheran Tempo Traveller Hire On Rent",
    "description": "Pune To Matheran Tempo Traveller Hire On Rent offers reliable and comfortable vehicles for travelers planning a trip from Pune to the scenic hill station of Matheran. These well-maintained tempo travellers are ideal for families, friends, or groups, providing spacious seating, luggage space, and professional drivers to ensure a safe and enjoyable journey. Flexible booking options and affordable rates make it convenient for weekend trips or longer stays."
  },
  {
    "name": "Matheran Tempo Traveller from Pune",
    "description": "Matheran Tempo Traveller from Pune provides convenient rental services for trips to Matheran. Equipped with comfortable seating, luggage capacity, and experienced drivers, these vehicles ensure a smooth and hassle-free journey. Ideal for sightseeing, family vacations, or group tours, this service prioritizes passenger comfort, safety, and punctuality."
  },
  {
    "name": "AC Tempo Traveller Pune to Matheran",
    "description": "AC Tempo Traveller Pune to Matheran offers air-conditioned vehicles for a cool and comfortable ride to the hill station. Spacious interiors, luggage-friendly design, and professional chauffeurs make it perfect for families, friends, or corporate groups, ensuring a relaxed and stress-free journey."
  },
  {
    "name": "Luxury Tempo Traveller Matheran Trip",
    "description": "Luxury Tempo Traveller Matheran Trip provides premium vehicles for a stylish and comfortable travel experience from Pune to Matheran. Equipped with reclining seats, entertainment features, and ample luggage space, these luxury tempo travellers are ideal for VIP travel, corporate trips, or special family outings."
  },
  {
    "name": "Family Tempo Traveller Matheran",
    "description": "Family Tempo Traveller Matheran ensures a safe, comfortable, and enjoyable journey for families traveling to Matheran. Spacious seating, child-friendly interiors, and experienced drivers make it perfect for weekend getaways, family vacations, or group outings."
  },
  {
    "name": "Group Travel Tempo Traveller Matheran",
    "description": "Group Travel Tempo Traveller Matheran caters to large groups traveling from Pune to Matheran. With ample seating, luggage capacity, and professional drivers, it offers a convenient and reliable solution for corporate outings, school trips, or friends traveling together."
  },
  {
    "name": "Affordable Tempo Traveller Matheran",
    "description": "Affordable Tempo Traveller Matheran provides budget-friendly travel without compromising comfort or safety. Well-maintained vehicles, skilled drivers, and flexible booking options make it an ideal choice for cost-conscious travelers planning trips to Matheran."
  },
  {
    "name": "Chauffeur Driven Tempo Traveller Matheran",
    "description": "Chauffeur Driven Tempo Traveller Matheran offers professional drivers to handle traffic, routes, and logistics, allowing passengers to relax throughout the journey. Spacious and comfortable, this service ensures a stress-free and safe trip to Matheran."
  },
  {
    "name": "Best Tempo Traveller Pune to Matheran",
    "description": "Best Tempo Traveller Pune to Matheran provides top-quality vehicles and service for a superior travel experience. Comfortable interiors, experienced drivers, and attention to passenger convenience ensure a smooth, safe, and enjoyable trip from Pune to Matheran."
  },
  {
    "name": "Pune Matheran Travel Vehicle",
    "description": "Pune Matheran Travel Vehicle offers dependable and spacious transport for individuals or groups visiting Matheran. Professional chauffeurs, ample luggage space, and well-maintained vehicles guarantee a safe, comfortable, and hassle-free journey."
  },
  {
    "name": "Tourist Tempo Traveller Matheran",
    "description": "Tourist Tempo Traveller Matheran provides vehicles specifically designed for sightseeing trips to Matheran. Comfortable seating, luggage-friendly interiors, and professional drivers ensure a relaxing and enjoyable travel experience for tourists."
  },
  {
    "name": "Hill Station Tempo Traveller Pune",
    "description": "Hill Station Tempo Traveller Pune caters to travelers heading to Matheran or other hill stations. Spacious, safe, and reliable vehicles with experienced drivers make long-distance travel comfortable, convenient, and stress-free."
  },
  {
    "name": "Weekend Trip Tempo Traveller Matheran",
    "description": "Weekend Trip Tempo Traveller Matheran offers reliable transport for short weekend getaways from Pune. Comfortable seating, professional drivers, and flexible booking make it perfect for family trips, friends’ outings, or small group tours."
  },
  {
    "name": "Holiday Travel Tempo Traveller",
    "description": "Holiday Travel Tempo Traveller provides dependable vehicles for leisure trips to Matheran. Well-maintained interiors, luggage space, and professional chauffeurs ensure a safe, comfortable, and enjoyable journey for all travelers."
  },
  {
    "name": "Matheran Tour Tempo Traveller",
    "description": "Matheran Tour Tempo Traveller offers organized and convenient transport for tours of Matheran from Pune. Spacious vehicles, experienced drivers, and comfortable interiors make sightseeing and hill station trips stress-free and enjoyable."
  }
],
"tableData": [
  ["Pune To Matheran Tempo Traveller Hire On Rent", "Matheran Tempo Traveller from Pune"],
  ["AC Tempo Traveller Pune to Matheran", "Luxury Tempo Traveller Matheran Trip"],
  ["Family Tempo Traveller Matheran", "Group Travel Tempo Traveller Matheran"],
  ["Affordable Tempo Traveller Matheran", "Chauffeur Driven Tempo Traveller Matheran"],
  ["Best Tempo Traveller Pune to Matheran", "Pune Matheran Travel Vehicle"],
  ["Tourist Tempo Traveller Matheran", "Hill Station Tempo Traveller Pune"],
  ["Weekend Trip Tempo Traveller Matheran", "Holiday Travel Tempo Traveller"],
  ["Matheran Tour Tempo Traveller", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune To Matheran Tempo Traveller Hire On Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable Pune to Matheran Tempo Traveller hire services, perfect for family trips, group outings, and scenic hill station travel."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Tempo Travellers",
    "WhyChoosedescription": "Enjoy a comfortable journey from Pune to Matheran in air-conditioned, well-maintained Tempo Travellers designed for group travel with ample seating and luggage space."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune–Matheran Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Matheran route, ensuring safe, smooth, and timely travel throughout your trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Pune to Matheran Tempo Traveller hire, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, itinerary planning, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Hire Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Pune to Matheran travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Matheran Tempo Traveller hire."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Matheran Tempo Traveller hire on rent?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained Tempo Travellers for travel from Pune to Matheran.'
  },
  {
    question: 'How can I book a Pune to Matheran Tempo Traveller with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating options are available for Pune to Matheran Tempo Traveller?',
    answer: 'We offer multiple seating options, including 9-seater, 12-seater, 13-seater, and 17-seater Tempo Travellers to suit your group size.'
  },
  {
    question: 'Are drivers included with the Tempo Traveller rental?',
    answer: 'Yes, all rentals include experienced and professional drivers familiar with the Pune–Matheran route.'
  },
  {
    question: 'Is the Pune to Matheran Tempo Traveller service available 24x7?',
    answer: 'Yes, our Pune to Matheran Tempo Traveller hire service is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before the trip?',
    answer: 'Yes, all Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Pune to Matheran rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your travel needs.'
  },
  {
    question: 'What payment options are available for Pune to Matheran Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Matheran trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sachin Jadhav',
    feedback: 'Booked a Pune to Matheran Tempo Traveller with Sanavi Travels. Very comfortable, punctual service, and a smooth trip. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Excellent experience! Clean Tempo Traveller, experienced driver, and great service throughout the Pune to Matheran journey.',
    rating: 5
  }
];







































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune To Matheran Tempo Traveller Hire On Rent - Sanavi Travels",
  "description": "Hire Pune to Matheran Tempo Traveller on rent with Sanavi Travels. AC and luxury tempo travellers for hill station trips, family holidays, group travel, weekend getaways, and comfortable chauffeur-driven travel to Matheran.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Pune To Matheran Tempo Traveller Hire On Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and luxury Tempo Travellers from Pune to Matheran with Sanavi Travels. Perfect for hill station tours, family trips, group travel, weekend getaways, and holiday travel in comfort."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/167.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomatherantempotraveller;